import '../styles/Common.css';
import '../styles/About.css';
import {useTranslation, Trans} from "react-i18next";
import {Helmet} from 'react-helmet-async';
import SEO from "./SEO";
import heroBackgroundImage from '../assets/images/hero_background/about_hero_bg_original4.jpg';
import React from "react";
import {useParams} from "react-router-dom";


const About = () => {
    const {t, i18n} = useTranslation(['about', 'common', 'title', 'home'])
    const isChinese = i18n.language === 'zh';
    const hero_list_4 = t(`hero_list_4`, {ns: 'home', returnObjects: true});
    const hero_list_5 = t(`hero_list_5`, {ns: 'home', returnObjects: true});

    return (
        <div className={"bg-white"}>
            <SEO title={t('about', {ns: 'html_title'})}></SEO>
{/*            <div className={"header-container"}>
                <div className={"header"}>
                    <div className={"header-title-1"}>{t('about')} {t('project_name_full', {ns: 'common'})}</div>
                    <div className={"header-title-2"}>{t('title')}</div>
                </div>
            </div>*/}
            <div className={"bg-cover bg-white bg-blend-multiply bg-bottom bg-no-repeat min-h-[350px] sm:min-h-[400px] w-full flex flex-col justify-start items-center p-6"}
                 style={{backgroundImage: `url(${heroBackgroundImage})`}}
            >
                <div className={"flex flex-col justify-center items-start max-w-[900px] mt-36 mb-16 md:mr-48"}>
                    <div className={`font-bold tracking-[.02em] text-white/90 leading-normal ${isChinese ? 'text-4xl sm:text-[3.5rem] sm:tracking-[.05em]' : 'text-4xl sm:text-[3rem] sm:tracking-[.03em]'}`}>
                        {t('about')}<br/>
                        {t('hero_heading_1')}
                    </div>
                </div>
            </div>
            <div className={"content-container py-24 max-w-[1500px] mx-auto"}>
                <div className={"flex flex-wrap justify-evenly items-start max-w-8xl mx-auto px-6 sm:px-12 pb-10 sm:pb-24 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    <div id={"logo_animation"} className={"flex justify-center items-center flex-col pt-0 pb-12 bg-white"}>
                        <img src={process.env.PUBLIC_URL + `/logo/bklaiss_logo.png`} className={"max-w-[265px] bg-white rounded-full p-[2px] sm:mr-10"} alt={"logo"}/>
                    </div>
                    <div className={"lg:max-w-[60%]"}>
                        <div className={"text-neutral-600 text-xl font-light font-sans leading-loose"}>
                            <div className={"mb-8 text-[#0076d6] font-semibold text-3xl"}>
                                {t('hero_heading_intro', {ns: 'home'})}
                            </div>
                            <p className="">
                                {t('hero_heading_2', {ns: 'home'})}
                            </p>
                            <p className="mt-4">
                                {t('hero_heading_3', {ns: 'home'})}
                            </p>
{/*                            <div className={"mb-8 flex justify-between items-center"}>
                                <div className={"mb-8 text-[#0076d6] font-semibold text-3xl"}>
                                    {t('hero_heading_4', {ns: 'home'})}
                                </div>
                                <ul className="mt-4">
                                    {hero_list_4 && hero_list_4.map((item, index) => (
                                        <li key={`hero_list_4_` + index} className="list-disc ml-8">
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                                <div className={"mb-8 text-[#0076d6] font-semibold text-3xl"}>
                                    {t('hero_heading_5', {ns: 'home'})}
                                </div>
                                <ul className="mt-4">
                                    {hero_list_5 && hero_list_5.map((item, index) => (
                                        <li key={`hero_list_5_` + index} className="list-disc ml-8">
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>*/}

                            {/*                                    <p className="mt-24">
                                联系我们：<a href={"mailto:contact@beijing.ai-safety-and-governance.institute"} target={"_blank"} rel="noreferrer">contact@beijing.ai-safety-and-governance.institute</a>
                            </p>*/}
                        </div>
                    </div>
                </div>
                <div className={"flex flex-wrap justify-between items-start max-w-8xl mx-auto px-6 sm:px-12 pb-36 rounded-3xl bg-cover bg-white bg-blend-multiply bg-center-top bg-no-repeat"}>
                    <div className={"lg:max-w-[45%] sm:px-4 pb-10"}>
                        <div className={"mb-8 text-[#0076d6] font-semibold text-3xl"}>
                            {t('hero_heading_4', {ns: 'home'})}
                        </div>
                        <ul className="mt-4 text-neutral-600 text-xl font-light font-sans leading-loose">
                            {hero_list_4 && hero_list_4.map((item, index) => (
                                <li key={`hero_list_4_` + index} className="list-disc ml-8">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className={"lg:max-w-[50%] sm:px-4 pb-10"}>
                        <div className={"mb-8 text-[#0076d6] font-semibold text-3xl"}>
                            {t('hero_heading_5', {ns: 'home'})}
                        </div>
                        <ul className="mt-4 text-neutral-600 text-xl font-light font-sans leading-loose">
                            {hero_list_5 && hero_list_5.map((item, index) => (
                                <li key={`hero_list_5_` + index} className="list-disc ml-8">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
